import styled from "styled-components";

export const Wrapper = styled.div`
  .form-div {
    border: 2px solid #dddddd;
    border-radius: 5px;
    padding: 30px 20px 10px 20px;
  }
  .label-col {
    display: flex;
    align-items: center;
    height: 40px;
    label {
      font-size: 17px;
      font-weight: 540;
    }
  }
  .textarea {
    border: 1px solid #dddddd;
    font-size: 15px;
    width: 100%;
    padding: 5px 0px 0px 15px;
  }
  .link {
    border: 1px solid #dddddd;
    font-size: 15px;
    border-radius: 5px;
  }
  input {
    ::placeholder {
      font-size: 15px;
    }
  }
  .sender-as,
  .sender-to {
    .ant-select-selector {
      border: 1px solid #dddddd !important;
      height: 40px !important;
    }
    .ant-select-selection-item,
    .ant-select-selection-search {
      padding-top: 5px;
    }
  }
  .ant-input {
    height: 40px !important;
  }
  .button-col {
    display: flex;
    justify-content: center;
  }
  @media screen and (max-width: 1000px) {
    .ant-form-item {
      margin-bottom: 0px !important;
    }
  }
  .date-picker{
    width: 100%;
  }


 
`;
